import { Injectable } from '@angular/core';

import { modeloGpsStorage } from "./data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class ModeloGpsService {

    constructor(
       private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(modeloGpsStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(modeloGpsStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(modeloGpsStorage + "-new");
    }

    templateResult = (function(state: any, isCreateNew: boolean) {
        let stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    text = state.modelo;
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/shared/modelo-gps.service.ts
 **/